/**
 * Trợ lý AI toàn cục — một entry cho bubble Hub và embed script.
 * Cùng điều kiện: đăng nhập + config_setting_active_ai.
 * Mặc định: React Hub (AiChatView + MS.AICoaching). Legacy: NEXT_PUBLIC_AI_LEGACY_EMBED=1.
 */
import React from 'react';
import { useRouter } from 'next/router';
import { AI_LEGACY_EMBED } from '@/components/common/aiAssistant/constants';
import { useActiveAiGate } from '@/components/common/aiAssistant/useActiveAiGate';
import { ToppionAILegacyEmbedRuntime } from '@/components/common/aiAssistant/ToppionAILegacyEmbedRuntime';
import { AiChatBubbleHub } from '@/components/common/AiChatBubble';
import { isActionPlanV2AiPath } from '@/components/Layout/FloatingAiAssistant';
import { canUseActionPlanV2AiAssistant } from '@/components/common/ActionPlanV2/constants';
import { useAuthStore } from '@/store/useAuthStore';
import { resolveProfilePhanHe } from '@/utils/phanHeStorage';
import { CONSTANTS } from '@/utils/constants';

/** Trợ lý BSC chỉ dành cho phân hệ BSC — ẩn ở Văn hóa và Quy trình. */
const AI_HIDDEN_PHAN_HE: readonly string[] = [CONSTANTS.PHAN_HE.VAN_HOA, CONSTANTS.PHAN_HE.QUY_TRINH];

type Props = {
  enabled?: boolean;
};

export function ToppionAIAssistant({ enabled = true }: Props) {
  const router = useRouter();
  const email = useAuthStore((s) => s.email);
  const { ready, stepSuggestOn } = useActiveAiGate({ enabled, loadStepSuggest: !AI_LEGACY_EMBED });

  if (!ready) return null;
  if (AI_HIDDEN_PHAN_HE.includes(resolveProfilePhanHe(router.pathname, router.asPath))) return null;
  if (isActionPlanV2AiPath(router.pathname || '') && canUseActionPlanV2AiAssistant(email)) return null;

  if (AI_LEGACY_EMBED) {
    return <ToppionAILegacyEmbedRuntime active />;
  }

  return <AiChatBubbleHub stepSuggestOn={stepSuggestOn} />;
}

export default ToppionAIAssistant;

// Re-export config keys (BscAiGate, cấu hình)
export { CONFIG_KEY_ACTIVE_AI, CONFIG_KEY_AI_STEP_SUGGEST } from '@/components/common/aiAssistant/constants';
